import { Component, ElementRef, Input } from '@angular/core';
import { BaseDesignerComponent } from '../base/base-designer-component';
import {
  DesignAttributeType,
  OutputAttribute,
  InputAttribute,
} from '../../../types/designer-attribute-type';
import { SxInternalStateDesignerService } from '../../../services/internal-state-designer-service';
import { ViewEngine, DescOptions, VEDependency } from '../../../types/view-engine.interface';
import { DesignerSelectItem } from '../../../types/product.type';

@Component({
  selector: 'sx-view-engine',
  templateUrl: './viewEngine.component.html',
})
export class SxViewEngine extends BaseDesignerComponent {
  @Input() customCode: string;
  interactionRules: DesignerSelectItem[] = [];
  flowpageOptions: DesignerSelectItem[] = [];
  flowOptions: DesignerSelectItem[] = [];

  constructor(
    container: ElementRef,
    public internalState: SxInternalStateDesignerService
  ) {
    super(container, 'SxViewEngine');
  }

  loadDefaults(): void {
    super.loadDefaults();
    this.controlContext = this.getViewEngineContext();
  }

  getDesignerInfo(): any {
    const info = super.getDesignerInfo();
    info['codViewEngine'] = this.controlContext.codViewEngine;
    info['moduleName'] = this.controlContext.moduleName;
    info['title'] = this.controlContext.title;
    info['outputs'] = this.controlContext.outputs;
    info['inputs'] = this.controlContext.inputs;
    info['outputType'] = this.controlContext.outputTypes;
    info['configuration'] = this.controlContext.configuration;
    return info;
  }

  buildAttributes(): void {
    super.buildAttributes();

    const codViewEngine = new DesignAttributeType(
      this.controlContext,
      'readonly',
      'codViewEngine',
      'View Engine Code'
    );

    const moduleName = new DesignAttributeType(
      this.controlContext,
      'readonly',
      'moduleName',
      'Module Name'
    );

    this.interactionRules = this.designerContext.product
      .interactionRules as Array<DescOptions>;
    this.flowpageOptions = this.designerContext.product
      .pageList as Array<DescOptions>;
    this.flowOptions = this.designerContext.product
      .flowList as Array<DescOptions>;

    const outputTypes: Array<DescOptions> = [
      { id: 'nonBlockingCall', description: 'Non Blocking Call' },
      { id: 'navigateToPage', description: 'Navigate to page' },
      { id: 'launchTransaction', description: 'Launch transactional flow' }    
    ];

    if(this.designerContext.isNonTransactional){
      outputTypes.push({ id: 'navigateToFlow', description: 'Navigate to Flow' });
    }else{
      //this makes no sence in NT flows
      outputTypes.push({ id: 'interationRuleEvent', description: 'Interation Rule Event' });
      outputTypes.push({ id: 'quoteGrid', description: 'Quote Grid' });
    }

    const inputTypes: DescOptions[] = [
      {
        id: 'constant',
        description: 'Constant',
      },
      {
        id: 'communication',
        description: 'Communication',
      },
    ];

    const input = new InputAttribute(
      this.controlContext,
      inputTypes,
      'inputs',
      'inputs',
      'Inputs'
    );

    const output = new OutputAttribute(
      this.controlContext,
      this.interactionRules,
      this.flowpageOptions,
      outputTypes,
      this.flowOptions,
      'outputs',
      'outputs',
      'Outputs'
    );
    
    const configuration = new DesignAttributeType(
      this.controlContext,
      'readonly',
      'configuration',
      'Configuration'
    );
    this.getDependenciesVE(configuration);

    this.attributes.push(
      codViewEngine,
      moduleName,
      output,
      input,
      configuration
    );
  }

  private getViewEngineContext(codViewEngine = ''): ViewEngine {
    return this.internalState
      .getViewEngines()
      .find((ve) => {
        if(codViewEngine !== '')
          return ve.codViewEngine.toLowerCase() === codViewEngine.toLowerCase()
        else
          return ve.codViewEngine.toLowerCase() === this.customCode.toLowerCase()
      });
  }

  private getDependenciesVE(configuration): void {
    const dependencies = configuration.value['veDependencies'] as VEDependency[];

    if(dependencies != null) {
      dependencies.forEach(dep => {
        const codDependency = typeof dep === 'object' ? dep.viewEngineCod : dep;
        const viewEngine = this.getViewEngineContext(codDependency);
        const index = dependencies.indexOf(dep);
        dependencies[index] = <VEDependency>{
          libCode: dep.libCode,
          viewEngineCod: viewEngine.codViewEngine,
          moduleName: viewEngine.moduleName,
          configuration: viewEngine.configuration
        };
      });
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/view-engine/viewEngine.component.ts